import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vuejs",
  "use": "vuejs-usage",
  "viewBox": "0 0 256 221",
  "content": "<symbol viewBox=\"0 0 256 221\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" preserveAspectRatio=\"xMidYMid\" id=\"vuejs\">\n\t<g>\n\t\t<path d=\"M204.8,0 L256,0 L128,220.8 L0,0 L50.56,0 L97.92,0 L128,51.2 L157.44,0 L204.8,0 Z\" fill=\"#41B883\" />\n\t\t<path d=\"M0,0 L128,220.8 L256,0 L204.8,0 L128,132.48 L50.56,0 L0,0 Z\" fill=\"#41B883\" />\n\t\t<path d=\"M50.56,0 L128,133.12 L204.8,0 L157.44,0 L128,51.2 L97.92,0 L50.56,0 Z\" fill=\"#35495E\" />\n\t</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol